export const BUZZ_WEIGHT_REVIEWS = 0.45;
export const BUZZ_WEIGHT_MEDIA = 0.35;
export const BUZZ_WEIGHT_FOOTFALL = 0.2;

export const BUZZ_SCORE_HEADROOM = 40;
export const BUZZ_SCORE_MAX_RATIO = 4;
export const BUZZ_SCORE_CURVE_K = 9;

export const formatCalcValue = value => {
  if (value == null || Number.isNaN(Number(value))) return '—';
  const number = Number(value);
  if (Math.abs(number - Math.round(number)) < 0.05) {
    return String(Math.round(number));
  }
  return number.toFixed(1);
};

export const formatCalcProduct = value => {
  if (value == null || Number.isNaN(Number(value))) return '—';
  return Number(value).toFixed(2);
};

export const formatCalcWeight = weight => Number(weight).toFixed(2);

export const computeWeightedLine = (score, weight) => {
  if (score == null || Number.isNaN(Number(score))) return null;
  return Number(score) * weight;
};

export const buildCalculatorLines = (reviews, media, footfall) => [
  {
    key: 'reviews',
    score: reviews,
    weight: BUZZ_WEIGHT_REVIEWS,
    product: computeWeightedLine(reviews, BUZZ_WEIGHT_REVIEWS),
  },
  {
    key: 'media',
    score: media,
    weight: BUZZ_WEIGHT_MEDIA,
    product: computeWeightedLine(media, BUZZ_WEIGHT_MEDIA),
  },
  {
    key: 'footfall',
    score: footfall,
    weight: BUZZ_WEIGHT_FOOTFALL,
    product: computeWeightedLine(footfall, BUZZ_WEIGHT_FOOTFALL),
  },
];

export const computeCompositeRawTotal = (reviews, media, footfall) => {
  const lines = buildCalculatorLines(reviews, media, footfall);

  if (
    lines.some(line => line.score == null || Number.isNaN(Number(line.score)))
  ) {
    return null;
  }

  return lines.reduce((sum, line) => sum + line.product, 0);
};

export const computeCompositeScore = (reviews, media, footfall) => {
  const total = computeCompositeRawTotal(reviews, media, footfall);
  if (total == null) return null;

  return Math.round(Math.max(0, Math.min(100, total)));
};
